'use strict';

import {
    addExportBtns,
    addSelectedCompanyHandler,
    companyGuard,
    getSelectedCompanyForUser
} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnHolidayPayObligationsTable = function () {
    const tableName = '#datatable-holiday-pay-obligations';

    if (!element_exists(tableName)) return false;

    loadTable();

    addSelectedCompanyHandler(loadTable);

    function loadTable() {
        let $table = $(tableName);
        /*TODO refactor to use method*/
        let selectedCompanyId = getSelectedCompanyForUser();

        if (companyGuard()) {
            $table.parents('.table-responsive').addClass('hidden');
            $table.DataTable().clear().draw();
            return;
        }
        const url = `/${selectedCompanyId}/holiday-pay-obligations/index`;

        if ($.fn.dataTable.isDataTable(tableName)) {
            $table.parents('.table-responsive').removeClass('hidden');

            $table.DataTable().ajax.url(url).load(function () {
                setTimeout(function () {
                    $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                }, 500);
            });
            return;
        }
        const namespace = `holiday-pay-obligations`;

        const columns = [
            {data: 'payroll_id'},
            {data: 'payroll.year'},
            {
                data: 'payroll.month',
                render: function (data, type, row) {
                    if (type === 'display' || type === 'filter') {
                        return allLangFiles.payrolls.edit.months[data];
                    }
                    return data;
                }
            },
            {data: 'entries_count'},
            {
                data: 'file_upload',
                render: function (data, type, row) {
                    if (!$table.data('upload-allowed')) return '';
                    /*Open dropzone*/
                    return `<button data-href="${row.company_id}/${namespace}/${row.payroll_id}/upload" class="btn btn-info btn-upload-holiday-obligation">${allLangFiles.forms.upload}</button>`;
                },
            },
            {
                data: 'actions',
                render: function (data, type, row) {

                    let $btnOpen = `<a href="${row.company_id}/${namespace}/${row.payroll_id}" class="btn btn-success">${allLangFiles.forms.open}</a>`;
                    if (!$table.data('upload-allowed')) {
                        return `
                            <div>
                                ${$btnOpen}
                            </div>
                            `;
                    }
                    return `
                        <form data-id="${row.payroll_id}" class="form-create-holiday-pay-obligation-export form-inline">
                            ${$btnOpen}
                            <div class="form-group">
                                <button
                                        class="btn-create-holiday-pay-obligation-export btn btn-info btn-md pull-right">
                                        ${allLangFiles['holiday-pay-obligations'].export}
                                </button>
                                <div class="loader-col hidden m-l-5">
                                    <div class="loader-parent">
                                        <img id="loadingSpinner" class="loader" src="/assets/gif/default.gif">
                                    </div>
                                </div>
                            </div>
                        </form>
                        `;
                },
            },
        ];

        /*Rules for filling the columns*/
        const columnDefs = [
            {visible: false, targets: 0, orderable: false},
            {targets: 4, orderable: false, class: 'text-right'},
            {targets: 5, orderable: false, class: 'text-right'},
        ];

        /*Important otherwise table misaligned*/
        $table.css('width', '100%');


        const dataTable = $table.DataTable({

            language: allLangFiles.datatables,
            rowId: 'id',
            ajax: {
                url: url,
                dataSrc: function (json) {
                    return json.data;
                },
            },
            columns: columns,
            columnDefs: columnDefs,
            order: [[1, "desc"], [2, "desc"]],
            scrollX: true,
            lengthMenu: [10, 25, 50, 75, 100],
            initComplete: function (settings, json) {
                $(tableName).parents('.table-responsive').removeClass('hidden');
                dataTable.draw();
            },
            drawCallback: function (settings) {
                $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
            },
        });
        addExportBtns($(tableName));
        const {$filterButtons} = redesignDataTablesHeader(tableName, true, null, false);
        $filterButtons.prepend($('#btn-create-holiday-pay-obligations'));
    }
};